import axios from "axios";
import Config from "../config";

const messageSystem = data => {
    return axios({
        method: "post",
        url: (Config.url || '') + "/api/v2/message-system",
        data: data
    });
};

export default messageSystem;
